module.exports = __webpack_public_path__ + "static/macbook-d5a263794d57f3da08f5f6fe0431407c.png";